import React from 'react';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import CardsSection from '../components/CardsSection';
import CarouselSection from '../components/CarouselSection';
import Showcase from '../components/Showcase';
import { Box, Typography } from '@mui/material';
import { refItems, tutItems } from '../data/SiteData';

const cardData = [
  {
    title: 'Reference Material',
    description: 'All your educational and research resources at your fingertips. Including links to publications and tools.',
    color: '#489596',
    buttonText: 'View All Material',
    link: '/resources/references',
  },
  {
    title: 'Videos and Tutorials',
    description: 'The latest video guides and tutorials about the human immune system',
    color: '#E67350',
    buttonText: 'View All Tutorials',
    link: '/resources/videos-tutorials',
  },
];

const Resources = () => {
    // Breadcrumb items
    const breadcrumbItems = [
        { title: 'Home', path: '/' },
        { title: 'Resources', path: '/resources' },
    ];

    return (
        <>
            <Navbar />
            <HeroBanner
                heroTitle="Resources"
                heroDescription="Find training aides, educational resources, tools, publications, videos and tutorials."
                imageUrl="/images/digiTwins.png"
                height="165px"
            />
            <Breadcrumb items={breadcrumbItems} />
            <CardsSection cardData={cardData} />
            <CarouselSection title="Reference Highlights" items={refItems} backgroundStyle="grey"/>
            <CarouselSection title="Latest Tutorials" items={tutItems} backgroundStyle="white"/>
            
            <Footer />
        </>
    );
};

export default Resources;
